import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import UserInfo from '@ifeng-fe/ui_pc_userInfo';
import Search from '@ifeng-fe/ui_pc_search';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <header className={styles.header}>
                <div className={styles.wrapper}>
                    <div className={styles.logo}>
                        <a href="https://www.ifeng.com/" target="_blank" rel={rel} aria-label="凤凰网">
                            <span />
                        </a>
                    </div>
                    <nav className={styles.nav} aria-label="面包屑">
                        <a href="https://www.ifeng.com/" target="_blank" rel={rel}>
                            凤凰网
                        </a>
                        <span className={styles.separator}>&gt;</span>
                        <a href="//news.ifeng.com/" target="_blank" rel={rel}>
                            资讯
                        </a>
                        <span className={styles.separator}>&gt;</span>
                        <span className={styles.current} aria-current="page">
                            原创
                        </span>
                    </nav>
                    <div className={styles.box}>
                        <div className={styles.search}>
                            <Chip id="20005" type="struct" title="搜索" groupName="头部" content={content}>
                                <Search expand />
                            </Chip>
                        </div>
                        <div className={styles.user}>
                            <NoSSR>
                                <UserInfo iconShow option={['login']} />
                            </NoSSR>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default errorBoundary(Header);
